import React from 'react';
import CustomFormInput from './CustomFormInput';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import { CustomCheckBox } from 'root/libs/exaforte/react/Form';
import { View } from 'react-native';
import { FieldSet } from 'root/globals/Form';
import { withStyles } from '@material-ui/core/styles';

const CustomFieldSet = withStyles({
    root: {
        flexDirection   : 'row-reverse',
        justifyContent  : 'flex-end',
        alignItems      : 'center',
        
        '& .MuiFormLabel-root'  : { marginBottom: 0 },
        '& .MuiCheckbox-root'   : { marginLeft: -9 }
    }
})(FieldSet);

export default class CustomCheckBoxGroup extends CustomFormInput {
    _onChange(value) {
        this.props.onChangeText(_.toggle_value_in_set(this.props.value || '', value));
    }
    
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {row: true})};
    }
    
    getElement() {
        let props = this.getSupportedProps();

        return <View className={['d-flex flex-' + (props.row ? 'row' : 'column')]}>
                {_.map(this.props.options, option => <Checkbox key={'checkbox-' + option.value} {..._.omit(option, ['onChangeText'])} checked={_.is_value_in_set(props.value, option.value) ? 't' : 'f'} onChange={this._onChange} />)}
            </View>;
    }
}

class Checkbox extends CustomComponent {
    _onChange() {
        this.props.onChange(this.props.value);
    }
    
    render() {
        return <CustomCheckBox label={this.props.label} value={this.props.checked} onChangeText={this._onChange} wrapper={CustomFieldSet} />;
    }
}